import { IUserData } from 'types/users/IUser';
import { APIFactory } from 'ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from 'ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';

export interface IGetActivityUsersAsyncProps {
  orderId: string;
}

export const getActivityUsersAsync = ({ orderId }: IGetActivityUsersAsyncProps) =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IUserData[]>(`/timber/api/internal/orders/${orderId}/actors`)
    .then((t) => t.data)
    .catch(axiosErrorHandler);
